import { PureComponent } from 'react';
import _ from 'lodash';

import { css } from '@emotion/react';
import { dashboard } from 'types';
import TagTypes from 'constants/TagTypes';
import icons from 'components/icons/svgr/tag-icons';

interface Props {
  isPartyCard?: boolean;
  tags: dashboard.Tag[];
  type: string;
}

const COLOR_VISIT_PRIMARY = 'var(--lilac-base)';
const COLOR_GUEST_PRIMARY = 'var(--blaze-base)';

class TagIconsList extends PureComponent<Props> {
  render() {
    const { tags, type, isPartyCard } = this.props;
    const onlyUniqueIcons = _.uniqBy(
      _.filter(tags, (tag) => !_.isEmpty(tag.icon)),
      'icon'
    );
    const sortedTags = _.sortBy(onlyUniqueIcons, 'ordering');

    const iconCss = css`
      cursor: inherit;
      ${type === TagTypes.VISIT && `color: ${COLOR_VISIT_PRIMARY};`}
      ${type === TagTypes.GUEST && `color: ${COLOR_GUEST_PRIMARY};`}
      ${isPartyCard &&
      `
        height: 16px;
        margin-right: 4px;
        width: 16px;
        vertical-align: middle;
      `}
    `;

    return _.map(sortedTags, (tag) => {
      const Icon = icons[tag.icon];
      return Icon ? (
        <Icon css={iconCss} key={tag.icon} data-for="tooltip" data-tip={tag.text} />
      ) : null;
    });
  }
}

export default TagIconsList;
